import { render, staticRenderFns } from "./print-view.vue?vue&type=template&id=8767e7bc&"
import script from "./print-view.vue?vue&type=script&lang=ts&"
export * from "./print-view.vue?vue&type=script&lang=ts&"
import style0 from "./print-view.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Sources\\nothegger.topwm\\Nothegger.TopWM.Warehouse.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8767e7bc')) {
      api.createRecord('8767e7bc', component.options)
    } else {
      api.reload('8767e7bc', component.options)
    }
    module.hot.accept("./print-view.vue?vue&type=template&id=8767e7bc&", function () {
      api.rerender('8767e7bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/projects/components/print-view.vue"
export default component.exports